import { constants } from 'appConstants';
import { useEffect } from 'react';
import { useChatContext } from '@ltvco/refresh-lib/v2';
import { useScreenSize } from '@ltvco/refresh-lib/utils';
import { MessagesContainer } from './components/MessagesContainer';
import { useLocation } from 'react-router-dom';
import { RecentReports } from 'routes/Dashboard/RecentReports/RecentReports';
import { ChatPageLayout } from './ChatPageLayout';
import { DamageAnalyzerPage } from '../../PhotoDamageAnalyzer/DamageAnalyzerPage';

const ChatPageContent = () => {
  const location = useLocation();
  const reportLibraryRoute = `${constants.links.chatAILink}/library`;
  const isReportLibraryOpen = location.pathname === reportLibraryRoute;
  const photoDamageRoute = `${constants.links.chatAILink}/photo-damage-analyzer`;
  const isPhotoDamageRoute = location.pathname === photoDamageRoute;

  const {
    messages,
    loadingStatus,
    showLanding,
    isLogoAnimating,
    logoAnimationPhase,
    shouldCloseReport,
    isReportOpen,
    setIsReportOpen,
    handleShouldCloseReport,
    sendMessage,
    handleFeatureNameChange,
  } = useChatContext();
  const { isMobile } = useScreenSize();
  useEffect(() => {
    if (!isPhotoDamageRoute) {
      handleFeatureNameChange('createSmartSearchBot');
    }
  }, [handleFeatureNameChange, isPhotoDamageRoute]);

  if (isReportLibraryOpen) {
    return <RecentReports isInChatPage />;
  }

  if (isPhotoDamageRoute) {
    return <DamageAnalyzerPage />;
  }

  return (
    <MessagesContainer
      messages={messages}
      loadingStatus={loadingStatus}
      onReportStateChange={setIsReportOpen}
      shouldCloseReport={shouldCloseReport}
      onReportCloseHandled={handleShouldCloseReport}
      showLanding={showLanding}
      isLogoAnimating={isLogoAnimating}
      logoAnimationPhase={logoAnimationPhase}
      onSendMessage={sendMessage}
      sx={{
        ...(isMobile &&
          !isReportOpen && {
            paddingTop: '0',
          }),
      }}
    />
  );
};

export const ChatPage = () => {
  return (
    <ChatPageLayout showChatInput>
      <ChatPageContent />
    </ChatPageLayout>
  );
};
